import { Translation } from 'cng-common/features/translations'
import { Button } from 'core-components/library/button'
import { ModalDialog } from 'core-components/library/modalDialog'

import styles from './HPContactsDuplicateDialog.module.scss'

interface IHPContactsDuplicateDialogProps {
  isShow: boolean
  onClose: () => void
}

export const HPContactsDuplicateDialog = ({ isShow, onClose }: IHPContactsDuplicateDialogProps) => {
  return (
    <ModalDialog
      show={isShow}
      onClose={() => onClose()}
      size={'xs'}
      content={() => (
        <div>
          <p className={styles.warning__title}>Warning!</p>
          <p className={styles.warning__text}>
            <Translation text="jbp-salesteam-contact-duplicate" />
          </p>
          <div className={styles.warning__buttons}>
            <Button
              variant={'contained'}
              className={styles.warning__close}
              onClick={() => onClose()}
              color={'grey'}
            >
              OK
            </Button>
          </div>
        </div>
      )}
    />
  )
}
